import {
    LEADS_SET_INTERVAL,
  } from '../constants'
  
  export function reducer(state, action) {
    if (action.type == LEADS_SET_INTERVAL) {
      return{
        ...state,
        interval: action.value
      }
    }else{
      return state;
    }
  }